// extracted by mini-css-extract-plugin
module.exports = {"line":"aldagram_line__1sSE5"};